import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, useHistory, useLocation } from 'react-router';
import { Button, Card, CardBody, CardHeader, Col, Collapse, Container, Form, Input, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, Row, Spinner, Table } from 'reactstrap';
import { Link } from 'react-router-dom';
import { ApplicationState } from '../../store';
import * as SessionMdl from '../../models/SessionModel';
import { LoadingIcon } from '../Misc/Loading';
import { SaCurrency, SaDate, SaLabel } from '../Misc/SawinComponents';
import { useEffect, useState } from 'react';
import * as CustomerRequestStore from '../../store/CustomerRequest';
import * as CustomerRequestMdls from '../../models/CustomerRequestBucket';
import * as CustomerRequestInitialDataStore from '../../store/CustomerRequestInitialData';
import * as CustomerRequestInitialDataMdls from '../../models/CustomerRequestInitialData';
import '../../../node_modules/cleave.js/dist/addons/cleave-phone.us'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
const Cleave = require('../../../node_modules/cleave.js/react');
//import Cleave from 'cleave.js';


type MyProps =
    { SessionState: SessionMdl.SessionModel, RequestState: CustomerRequestMdls.CustomerRequestBucketModel, InitialData: CustomerRequestInitialDataMdls.CustomerRequestInitialData } & typeof CustomerRequestStore.actionCreators & typeof CustomerRequestInitialDataStore.actionCreators;

const CustomerRequest: React.FunctionComponent<MyProps> = (props: MyProps) => {

    const history= useHistory();

    const location = useLocation();

    var requestState: { ServiceType: string } = { ServiceType: '' };
    requestState = location.state;   

    useEffect(() => {             
        if (props.RequestState.success == 'Y') {            
            //history.replace(`Request/${requestState.ServiceType}`);
            history.goBack();
            props.resetState();
        }
        if (props.RequestState.error) {
            alert(props.RequestState.error);
        }

        if (!CustomerRequestLocal.requestedTime && props.InitialData.items.timePromissedOptions && props.InitialData.items.timePromissedOptions.length > 0) {
            CustomerRequestLocal.requestedTime = props.InitialData.items.timePromissedOptions[0].code;        
        }

    }, [props]);

    useEffect(() => {

        if (props.SessionState.SelectedAR.useWhiteBoard) {
            history.replace('Whiteboard');
        }
        if (!props.InitialData.loaded) {
            props.loadInitialData(new Date(), '', 'S');            
        }
    }, []);

    const [CustomerRequestLocal, updateCustomerRequestInfo] = useState<CustomerRequestMdls.CustomerRequestBucketModel>({ ...CustomerRequestMdls.initialState, serviceOrProposal: requestState.ServiceType.toUpperCase()=="QUOTE"?"P":"S" });

    const SubmitEvent = (e: React.FormEvent) => {
        console.log(CustomerRequestLocal);
        e.preventDefault();
        props.request(CustomerRequestLocal);
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement> | React.ChangeEvent<HTMLTextAreaElement>) => {
        e.preventDefault();
        var valueChanged = { [e.target.id]: e.target.value };
        updateCustomerRequestInfo({ ...CustomerRequestLocal, ...valueChanged });
    }

    const handleDateChange = (e: any) => {
        var myNewDate = new Date(e);
        myNewDate.setHours(10);
        updateCustomerRequestInfo({ ...CustomerRequestLocal, requestDate: myNewDate});
    }

    const handleCleveChange = (e: any) => {
        e.preventDefault();
        var valueChanged = { [e.target.id]: e.target.rawValue };
        updateCustomerRequestInfo({ ...CustomerRequestLocal, ...valueChanged });

    }

    const RequestBtn = () => {
        if (!props.RequestState.processing) {
            return (<input type="submit" value="Submit" className="btn btn-success" id="RequestBtn" name="RequestBtn" />);
        } else {
            return (<span>Loading<Spinner size="sm" color="primary" /></span>);
        }
    }

    return (
        <Container fluid={true}>
            <LoadingIcon loading={props.InitialData.loading} title={props.SessionState.SelectedSM.id + " - " + props.SessionState.SelectedSM.name.displayName} address={props.SessionState.SelectedSM.address} />
            {<Form onSubmit={SubmitEvent}>
                <Card className="customer_request-card">
                    <CardHeader className="center-align">
                        {props.SessionState.SelectedSM.address.line1}
                     </CardHeader>
                    <CardBody>
                        <Row>
                            <Col xs={12}>
                                <SaLabel Text={"Contact Name"} />
                                <input type="text" required onChange={handleChange} className="form-control" key="contactName" id="contactName" name="contactName" value={CustomerRequestLocal.contactName} />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <SaLabel Text={"Phone #"} />                                
                                <Cleave
                                    required
                                    options={{
                                        uppercase: true,
                                        //delimiters: [' ', ' '],
                                        blocks: [3, 3, 4],
                                        numericOnly: true
                                    }} className="form-control"
                                    onChange={handleCleveChange}
                                    key="contactPhone" id="contactPhone" name="contactPhone"
                                    value={CustomerRequestLocal.contactPhone}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                {requestState.ServiceType.toUpperCase() != "QUOTE" ? <SaLabel Text={"Reason"} /> : <SaLabel Text={"Description"} />}
                                <textarea required rows={3} onChange={handleChange} className="form-control" key="descriptionOfWork" id="descriptionOfWork" name="descriptionOfWork" value={CustomerRequestLocal.descriptionOfWork} />
                            </Col>
                        </Row>        
                        
                        {requestState.ServiceType.toUpperCase() != "QUOTE" &&
                            <span>
                            <Row>
                                <Col xs={12}>
                                    <SaLabel Text={"Prefered Date"} />
                                    <DatePicker className="form-control"
                                        id="requestDate" name="requestDate"
                                        minDate={new Date()}
                                        selected={CustomerRequestLocal.requestDate}
                                        onChange={handleDateChange} />                                     
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12}>
                                    <SaLabel Text={"Prefered Time"} />
                                    <Input type="select" id="requestedTime" name="requestedTime" value={CustomerRequestLocal.requestedTime} onChange={handleChange}>                                        
                                        {props.InitialData.items.timePromissedOptions &&
                                            props.InitialData.items.timePromissedOptions.map((item, index) =>
                                                <option key={item.code} value={item.code}>{item.description}</option>)
                                        }                                        
                                    </Input>
                                </Col>
                            </Row>
                            </span>
                        }                        
                    </CardBody>
                </Card>
                {requestState.ServiceType.toUpperCase() != "QUOTE" &&
                    <Card className='customer_request-message-card'>
                        <CardBody>
                            {props.InitialData.items.serviceRequestMessage &&
                                <div dangerouslySetInnerHTML={{ __html: props.InitialData.items.serviceRequestMessage }}  ></div>
                            }
                        </CardBody>
                    </Card>
                }
                <Card className='customer_request-btn-card'>
                    <CardBody>                        
                        <RequestBtn />
                    </CardBody>
                </Card>
                </Form>
            }
        </Container>
    );
}

export default connect((state: ApplicationState) =>
({
    ...{
        RequestState: state.customerRequestState,
        InitialData: state.customerRequestInitialDataState,
        SessionState: state.sessionState
    }
}),
    { ...CustomerRequestStore.actionCreators, ...CustomerRequestInitialDataStore.actionCreators })(CustomerRequest as any);